import styled from 'styled-components';

import Button from '../../elements/Button';

const ActionBtn = styled(Button).attrs(({ modifiers }) => ({
  modifiers: ['small'].concat(modifiers),
}))`
  margin-left: 1.25rem;
`;

export default ActionBtn;
